/* @flow */
import React from 'react';
import classnames from 'classnames/bind';

import s from './DropdownButton.styl';
const cx = classnames.bind(s);
import {Button, IconButton, IconButtonPure} from 'trustar-2.0/components/Button';

type CounterBadgeProps = {
  count: number,
};
export class CounterBadge extends React.Component {
  props: CounterBadgeProps;
  render() {
    const { count } = this.props;
    return (
      <div className={cx('CounterBadge', { wide: count > 9 })}>
        {count < 10 ? count : '9+'}
      </div>
    );
  }
}

type DropdownButtonProps = {
  children?: any,
  className?: string,
  onClick: (e?: Event) => void,
  isOpen: boolean,
};
export class DropdownButton extends React.Component {
  props: DropdownButtonProps;

  render() {
    const { onClick, children, isOpen, className } = this.props;
    return (
      <Button
        fill={'none'}
        onClick={onClick}
        className={cx('DropdownButton', className, { isOpen })}>
        {children}
      </Button>
    );
  }
}



// WEBPACK FOOTER //
// ./web_modules/trustar/components/DropdownButton.js